import { Box, Typography, Fab, darken } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from '@mui/styles';
import clsx from "clsx";

// common

const BannerSection = () => {

  return (
    <Box component="section" className="section" id="intro" sx={{ pb: 0 }}>
      <Box sx={{ background: { sm: "url(./assets/banner/data_analysis.jpg) center center/cover no-repeat", xs: '#0060fb' } }}>
        <Box sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 1rem",
          maxWidth: "1170px",
          margin: "0 auto",
          minHeight: '360px'
        }}>
          <Box sx={{
            width: '360px',
            pt: 5
          }}>
            <Typography component="div" sx={{ fontSize: '48px', color: '#ffffff', mb: 2 }}>Data Analysis</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '16px', color: '#ffffff', mb: 2 }}>データのクレンジングから分析アルゴリズムの構築まで展開し、</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '16px', color: '#ffffff' }}>データ分析を通じて構築されたアルゴリズムをシステムに実装します。</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { BannerSection };
